(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAboutTimeline(scope) {
      var items = (scope || document).querySelectorAll('.atl__item');
      if (!items.length) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) {
        items.forEach(function (i) { i.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (i) { io.observe(i); });
    }
    initAboutTimeline(document);
    document.addEventListener('shopify:section:load', function (e) {
      initAboutTimeline(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["byob-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('[data-byob-form]');
    forms.forEach(function (form) {
      var tiers = [];
      try { tiers = JSON.parse(form.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
      tiers = tiers.filter(function (t) { return t && t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });

      var items = [].slice.call(form.querySelectorAll('[data-byob-item]'));
      var totalEl = form.querySelector('[data-byob-total]');
      var unitEl = form.querySelector('[data-byob-unit]');
      var nowEl = form.querySelector('[data-byob-esttotal]');
      var wasEl = form.querySelector('[data-byob-subtotal]');
      var saveEl = form.querySelector('[data-byob-save]');
      var fillEl = form.querySelector('[data-byob-fill]');
      var msgEl = form.querySelector('[data-byob-msg]');
      var cta = form.querySelector('[data-byob-cta]');

      function inr(paise) { return '₹' + Number(Math.round(paise / 100)).toLocaleString('en-IN'); }
      function qtyOf(it) { return parseInt(it.getAttribute('data-qty') || '0', 10) || 0; }

      function render() {
        var total = 0, sub = 0;
        items.forEach(function (it) {
          var q = qtyOf(it);
          total += q;
          sub += q * (parseInt(it.getAttribute('data-price') || '0', 10) || 0);
        });

        var pct = 0;
        tiers.forEach(function (t) { if (total >= t.qty && t.pct > pct) { pct = t.pct; } });
        var save = Math.round(sub * pct / 100);

        totalEl.textContent = total;
        if (unitEl) { unitEl.textContent = total === 1 ? 'bottle' : 'bottles'; }
        nowEl.textContent = inr(sub - save);
        if (pct > 0) {
          wasEl.textContent = inr(sub); wasEl.hidden = false;
          saveEl.textContent = 'Save ' + inr(save) + ' (' + pct + '% off)'; saveEl.hidden = false;
        } else {
          wasEl.hidden = true; saveEl.hidden = true;
        }

        var next = null;
        for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > total) { next = tiers[i]; break; } }

        if (total === 0 && tiers.length) {
          msgEl.textContent = 'Add ' + tiers[0].qty + ' bottles to unlock ' + tiers[0].pct + '% off.';
        } else if (next) {
          var need = next.qty - total;
          var lead = pct > 0 ? ('You’re getting ' + pct + '% off. ') : '';
          msgEl.textContent = lead + 'Add ' + need + ' more ' + (need === 1 ? 'bottle' : 'bottles') + ' for ' + next.pct + '% off.';
        } else if (pct > 0) {
          msgEl.textContent = 'Nice, you’ve unlocked the biggest saving: ' + pct + '% off.';
        } else {
          msgEl.textContent = '';
        }

        var frac = 1;
        if (next) {
          var segStart = 0;
          for (var j = 0; j < tiers.length; j++) { if (tiers[j].qty <= total) { segStart = tiers[j].qty; } }
          frac = (total - segStart) / (next.qty - segStart);
        }
        if (frac < 0) { frac = 0; } if (frac > 1) { frac = 1; }
        fillEl.style.width = (frac * 100) + '%';

        cta.disabled = total < 1;
      }

      function setQty(it, q) {
        if (q < 0) { q = 0; } if (q > 99) { q = 99; }
        it.setAttribute('data-qty', q);
        var out = it.querySelector('[data-byob-qty]'); if (out) { out.value = q; }
        var idI = it.querySelector('[data-byob-id]');
        var qI = it.querySelector('[data-byob-qtyinput]');
        if (q > 0) {
          if (idI) { idI.disabled = false; }
          if (qI) { qI.disabled = false; qI.value = q; }
        } else {
          if (idI) { idI.disabled = true; }
          if (qI) { qI.disabled = true; qI.value = 0; }
        }
        render();
      }

      items.forEach(function (it) {
        it.setAttribute('data-qty', '0');
        var dec = it.querySelector('[data-byob-dec]');
        var inc = it.querySelector('[data-byob-inc]');
        var field = it.querySelector('[data-byob-qty]');
        if (dec) { dec.addEventListener('click', function () { setQty(it, qtyOf(it) - 1); }); }
        if (inc) { inc.addEventListener('click', function () { setQty(it, qtyOf(it) + 1); }); }
        if (field) {
          field.addEventListener('focus', function () { field.select(); });
          field.addEventListener('input', function () {
            var digits = (field.value || '').replace(/[^0-9]/g, '');
            if (digits.length > 2) { digits = digits.slice(0, 2); }
            if (digits !== field.value) { field.value = digits; }
            var q = digits === '' ? 0 : parseInt(digits, 10);
            if (q > 99) { q = 99; field.value = '99'; }
            it.setAttribute('data-qty', q);
            var idI = it.querySelector('[data-byob-id]');
            var qI = it.querySelector('[data-byob-qtyinput]');
            if (q > 0) { if (idI) { idI.disabled = false; } if (qI) { qI.disabled = false; qI.value = q; } }
            else { if (idI) { idI.disabled = true; } if (qI) { qI.disabled = true; qI.value = 0; } }
            render();
          });
          field.addEventListener('blur', function () { setQty(it, qtyOf(it)); });
        }
      });

      form.addEventListener('submit', function () {
        setTimeout(function () { items.forEach(function (it) { setQty(it, 0); }); }, 80);
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function drawer() { return document.getElementById('CartDrawer'); }

    function openDrawer() {
      var d = drawer();
      if (!d) return;
      var wasOpen = d.classList.contains('is-open');
      d.classList.add('is-open');
      d.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      if (!wasOpen) {
        var close = d.querySelector('.cdrawer__close');
        if (close) close.focus();
      }
    }

    function closeDrawer() {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('inert', '');
      document.body.style.overflow = '';
      var trigger = document.querySelector('.header__cart');
      if (trigger) trigger.focus();
    }

    function showError(msg) {
      var d = drawer();
      if (!d) return;
      var box = d.querySelector('[data-cart-error]');
      if (box) { box.textContent = msg; box.hidden = false; }
      openDrawer();
    }

    function captureFocus(cur) {
      var a = document.activeElement;
      if (!a || !cur.contains(a)) return null;
      var key = a.getAttribute('data-key');
      if (!key) return null;
      var type = a.hasAttribute('data-qty-up') ? 'data-qty-up'
        : a.hasAttribute('data-qty-down') ? 'data-qty-down'
        : a.hasAttribute('data-qty-set') ? 'data-qty-set' : null;
      if (!type) return null;
      return { key: key, type: type };
    }

    function restoreFocus(cur, info) {
      if (!info) return;
      var safeKey = (window.CSS && CSS.escape) ? CSS.escape(info.key) : info.key.replace(/"/g, '\\"');
      var el = cur.querySelector('[' + info.type + '][data-key="' + safeKey + '"]');
      if (el) el.focus();
    }

    function setCount(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
        else { el.setAttribute('hidden', ''); }
      });
      document.querySelectorAll('.header__cart').forEach(function (a) {
        a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' item(s)');
      });
    }

    function refresh() {
      return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j['cart-drawer'];
          if (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('#CartDrawer');
            var cur = drawer();
            if (fresh && cur) {
              var focusInfo = captureFocus(cur);
              var oldBody = cur.querySelector('.cdrawer__body');
              var scrollPos = oldBody ? oldBody.scrollTop : 0;
              cur.innerHTML = fresh.innerHTML;
              var newBody = cur.querySelector('.cdrawer__body');
              if (newBody) newBody.scrollTop = scrollPos;
              restoreFocus(cur, focusInfo);
            }
          }
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(setCount);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('.js-cart-add') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var hasIcon = btn ? !!btn.querySelector('svg') : false;
      var original = btn && !hasIcon ? btn.textContent : '';
      if (btn) { btn.disabled = true; if (hasIcon) { btn.classList.add('is-loading'); } else { btn.textContent = 'Adding…'; } }
      function restore() { if (btn) { btn.disabled = false; if (hasIcon) { btn.classList.remove('is-loading'); } else { btn.textContent = original; } } }
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            restore();
            showError(res.json && res.json.description ? res.json.description : 'Sorry, this item could not be added.');
            return;
          }
          return refresh().then(function () {
            restore();
            var d = drawer();
            if (d && d.hasAttribute('data-auto-open')) { openDrawer(); return; }
            if (btn) {
              btn.classList.add('is-added');
              if (!hasIcon) { btn.textContent = 'Added ✓'; }
              setTimeout(function () {
                btn.classList.remove('is-added');
                if (!hasIcon) { btn.textContent = original; }
              }, 1500);
            }
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.classList.remove('badge-pop');
              void el.offsetWidth;
              el.classList.add('badge-pop');
            });
          });
        })
        .catch(restore);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var cartIcon = e.target.closest('.header__cart');
      if (cartIcon) { e.preventDefault(); openDrawer(); return; }
      var el = e.target.closest('[data-qty-up], [data-qty-down], [data-qty-set]');
      if (!el) return;
      var key = el.getAttribute('data-key');
      if (!key) return;
      var qty;
      if (el.hasAttribute('data-qty-set')) {
        var v = el.getAttribute('data-qty-set');
        qty = v ? parseInt(v, 10) || 0 : 0;
      } else {
        var wrap = el.closest('.cdrawer__qty') || el.parentNode;
        var span = wrap ? wrap.querySelector('[data-qty]') : null;
        var cur = parseInt(span ? span.textContent : '1', 10) || 1;
        qty = el.hasAttribute('data-qty-up') ? cur + 1 : cur - 1;
        if (qty < 0) qty = 0;
      }
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () {
          var d = drawer();
          if (d && d.classList.contains('is-open')) openDrawer();
        });
    });

    document.addEventListener('keydown', function (e) {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var f = d.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled])');
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var menu = document.querySelector('[data-menu-panel]');
    var burger = document.querySelector('[data-menu-open]');
    if (!menu || !burger) return;
    var panel = menu.querySelector('.header-menu__panel');

    function focusables() {
      return menu.querySelectorAll('a[href], button:not([disabled])');
    }
    function openMenu() {
      menu.classList.add('is-open');
      menu.removeAttribute('inert');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (panel) panel.focus();
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('inert', '');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      burger.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { openMenu(); return; }
      if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
      if (e.target.closest('[data-menu-link]')) { closeMenu(); }
    });

    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeMenu(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hero').forEach(function (hero) {
      var slides = hero.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var i = 0;
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHowItWorks(scope) {
      var roots = (scope || document).querySelectorAll('.hiw');
      if (!roots.length) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) return;
      roots.forEach(function (rootEl) {
        if (rootEl.classList.contains('hiw--reveal')) return;
        var items = rootEl.querySelectorAll('.hiw__step, .hiw__feat');
        if (!items.length) return;
        rootEl.classList.add('hiw--reveal');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        items.forEach(function (item) { io.observe(item); });
      });
    }
    initHowItWorks(document);
    document.addEventListener('shopify:section:load', function (e) {
      initHowItWorks(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-nutrition"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIngredients(scope) {
      var roots = (scope || document).querySelectorAll('.ingr');
      if (!roots.length) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) return;
      roots.forEach(function (rootEl) {
        if (rootEl.classList.contains('ingr--reveal')) return;
        var cards = rootEl.querySelectorAll('.ingr__card');
        if (!cards.length) return;
        rootEl.classList.add('ingr--reveal');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        cards.forEach(function (card) { io.observe(card); });
      });
    }
    initIngredients(document);
    document.addEventListener('shopify:section:load', function (e) {
      initIngredients(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-cart-page]');
    if (!form) return;
    var updateBtn = form.querySelector('[name="update"]');

    function submitUpdate() {
      if (updateBtn) { updateBtn.click(); }
      else if (form.requestSubmit) { form.requestSubmit(); }
      else { form.submit(); }
    }

    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', submitUpdate);
    });

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page-qty]');
      if (!btn) return;
      var wrap = btn.closest('.cartpage__qty');
      var input = wrap ? wrap.querySelector('[data-cart-qty]') : null;
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-page-qty'), 10) || 0;
      var next = (parseInt(input.value, 10) || 0) + step;
      if (next < 0) next = 0;
      input.value = next;
      submitUpdate();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncQty(root, val) {
      if (!root) return;
      root.querySelectorAll('.pdp__sticky input[name="quantity"]').forEach(function (q) { q.value = val; });
    }

    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-rev-more]');
      if (!more) return;
      var root = more.closest('.pdp__reviews');
      if (!root) return;
      root.querySelectorAll('.rev__item--extra').forEach(function (li) { li.hidden = false; });
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
    });

    document.addEventListener('input', function (e) {
      var q = e.target.closest('.pdp__stepper input[name="quantity"]');
      if (!q) return;
      var typed = parseInt(q.value, 10);
      if (!typed || typed < 1) typed = 1;
      syncQty(q.closest('.pdp'), typed);
    });

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        var root = thumb.closest('.pdp');
        if (!root) return;
        var main = root.querySelector('.pdp__main img');
        if (main) {
          main.src = thumb.getAttribute('data-full');
          main.removeAttribute('srcset');
        }
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }
      var step = e.target.closest('[data-step]');
      if (step) {
        var input = step.parentNode.querySelector('input[name="quantity"]');
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          val += parseInt(step.getAttribute('data-step'), 10);
          if (val < 1) val = 1;
          input.value = val;
          syncQty(step.closest('.pdp'), val);
        }
      }
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-variant-select]');
      if (!sel) return;
      var root = sel.closest('.pdp');
      if (!root) return;
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;

      root.querySelectorAll('form input[name="id"]').forEach(function (i) { i.value = opt.value; });

      var price = opt.getAttribute('data-price');
      if (price) {
        root.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = price; });
      }
      var compare = opt.getAttribute('data-compare');
      root.querySelectorAll('[data-compare]').forEach(function (c) {
        if (compare) { c.textContent = compare; c.hidden = false; } else { c.hidden = true; }
      });

      var available = opt.getAttribute('data-available') === 'true';
      root.querySelectorAll('[data-atc]').forEach(function (b) {
        b.disabled = !available;
        b.textContent = available ? (b.getAttribute('data-add-label') || 'Add to cart') : (b.getAttribute('data-soldout-label') || 'Sold out');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-predict-form]');
  if (!form) return;
  var input = form.querySelector('[data-predict-input]');
  var box = form.querySelector('[data-predict-results]');
  var status = form.querySelector('[data-predict-status]');
  var base = form.getAttribute('data-suggest-url') || '/search/suggest';
  var timer, controller, activeIndex = -1;
  var SEARCH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function closeBox() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); activeIndex = -1; }
  function options() { return [].slice.call(box.querySelectorAll('a.search__predict-item')); }
  function setActive(i) {
    var opts = options();
    opts.forEach(function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-selected'); });
    if (i >= 0 && i < opts.length) {
      activeIndex = i;
      opts[i].classList.add('is-active');
      opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      opts[i].scrollIntoView({ block: 'nearest' });
    } else { activeIndex = -1; input.removeAttribute('aria-activedescendant'); }
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var html = '<a class="search__predict-item search__predict-all" role="option" href="' + form.action + '?q=' + encodeURIComponent(q) + '">'
      + '<span class="search__predict-thumb search__predict-thumb--c">' + SEARCH_ICON + '</span>'
      + '<span class="search__predict-title">Search for &ldquo;' + esc(q) + '&rdquo;</span></a>';
    if (products.length) {
      html += '<p class="search__predict-head">Products</p>';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        html += '<a class="search__predict-item" role="option" href="' + p.url + '">'
          + (img ? '<img class="search__predict-thumb" src="' + img + '" alt="" loading="lazy" width="40" height="40">'
                 : '<span class="search__predict-thumb"></span>')
          + '<span class="search__predict-title">' + esc(p.title) + '</span></a>';
      });
    }
    if (collections.length) {
      html += '<p class="search__predict-head">Collections</p>';
      collections.forEach(function (c) {
        html += '<a class="search__predict-item" role="option" href="' + c.url + '">'
          + '<span class="search__predict-thumb search__predict-thumb--c"></span>'
          + '<span class="search__predict-title">' + esc(c.title) + '</span></a>';
      });
    }
    if (!products.length && !collections.length) {
      html += '<p class="search__predict-empty">No matches yet. Press Enter to search &ldquo;' + esc(q) + '&rdquo;.</p>';
    }
    box.innerHTML = html;
    options().forEach(function (o, idx) { o.id = 'search-predict-option-' + idx; });
    box.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    input.removeAttribute('aria-activedescendant');
    activeIndex = -1;
    if (status) {
      var total = products.length + collections.length;
      status.textContent = total ? total + ' suggestion' + (total === 1 ? '' : 's') + ' available.' : 'No suggestions found.';
    }
  }

  function fetchSuggest(q) {
    if (controller) { controller.abort(); }
    controller = new AbortController();
    var url = base + '.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(q, data); })
      .catch(function (e) { if (e.name !== 'AbortError') { closeBox(); } });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { closeBox(); return; }
    timer = setTimeout(function () { fetchSuggest(q); }, 180);
  });
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && box.innerHTML) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  });
  input.addEventListener('keydown', function (e) {
    if (box.hidden) { return; }
    var opts = options();
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1 >= opts.length ? 0 : activeIndex + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1 < 0 ? opts.length - 1 : activeIndex - 1); }
    else if (e.key === 'Enter') { if (activeIndex >= 0 && opts[activeIndex]) { e.preventDefault(); window.location.href = opts[activeIndex].href; } }
    else if (e.key === 'Escape') { closeBox(); }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) { closeBox(); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-collect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'profrsh-reviews-done';

    function readDone() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }

    function markDone(handle) {
      try {
        var d = readDone();
        if (d.indexOf(handle) === -1) {
          d.push(handle);
          localStorage.setItem(KEY, JSON.stringify(d));
        }
      } catch (e) {}
    }

    function refresh(root) {
      var picked = [];
      root.querySelectorAll('[data-revc-check]').forEach(function (c) {
        if (c.checked) picked.push(c.value);
      });
      var d = readDone();
      root.querySelectorAll('[data-revc-row]').forEach(function (row) {
        var h = row.getAttribute('data-revc-row');
        row.hidden = picked.indexOf(h) === -1;
        row.classList.toggle('is-done', d.indexOf(h) !== -1);
      });
      var queue = root.querySelector('[data-revc-queue]');
      if (queue) queue.hidden = picked.length === 0;
    }

    document.addEventListener('change', function (e) {
      var c = e.target.closest('[data-revc-check]');
      if (!c) return;
      var root = c.closest('.revc');
      if (root) refresh(root);
    });

    document.addEventListener('click', function (e) {
      var go = e.target.closest('[data-revc-go]');
      if (!go) return;
      markDone(go.getAttribute('data-revc-go'));
      var root = go.closest('.revc');
      setTimeout(function () { if (root) refresh(root); }, 400);
    });

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.revc').forEach(refresh);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-track-form]');
      if (!form) return;
      e.preventDefault();
      var url = form.getAttribute('data-track-url');
      var param = form.getAttribute('data-track-param');
      var input = form.querySelector('input[name="tracking"]');
      var err = form.querySelector('[data-track-error]');
      var val = input ? input.value.trim() : '';
      if (!url) { return; }
      if (!val) {
        if (err) { err.textContent = 'Please enter your tracking number.'; err.hidden = false; }
        return;
      }
      if (err) { err.hidden = true; }
      var dest = url;
      if (param) {
        dest = url + (url.indexOf('?') > -1 ? '&' : '?') + encodeURIComponent(param) + '=' + encodeURIComponent(val);
      }
      window.open(dest, '_blank', 'noopener');
    });
  })();

  (function () {
    var panel = document.querySelector('[data-track-native]');
    if (!panel) return;
    var base = (panel.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var form = panel.querySelector('[data-native-form]');
    var input = panel.querySelector('input[name="value"]');
    var labelEl = panel.querySelector('[data-track-label]');
    var hintEl = panel.querySelector('[data-track-hint]');
    var errEl = panel.querySelector('[data-track-error]');
    var results = panel.querySelector('[data-track-results]');
    var submitBtn = panel.querySelector('[data-track-submit]');
    var submitLabel = submitBtn ? submitBtn.textContent : 'Track';
    var mode = 'awb';

    var text = {
      awb: { label: panel.getAttribute('data-awb-label') || 'AWB number', ph: panel.getAttribute('data-awb-ph') || '', hint: panel.getAttribute('data-awb-hint') || '' },
      order: { label: panel.getAttribute('data-order-label') || 'Order ID', ph: panel.getAttribute('data-order-ph') || '', hint: panel.getAttribute('data-order-hint') || '' }
    };

    function applyMode(m) {
      mode = m;
      if (labelEl) labelEl.textContent = text[m].label;
      if (input) { input.placeholder = text[m].ph; input.value = ''; input.focus(); }
      if (hintEl) { hintEl.textContent = text[m].hint; hintEl.hidden = !text[m].hint; }
      panel.querySelectorAll('.track__toggle-opt').forEach(function (o) { var r = o.querySelector('input'); o.classList.toggle('is-active', !!(r && r.checked)); });
      if (errEl) errEl.hidden = true;
      if (results) { results.hidden = true; results.innerHTML = ''; }
    }
    panel.querySelectorAll('input[name="track-mode"]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) applyMode(r.value); }); });

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function clean(s) { s = String(s == null ? '' : s).replace(/\bnull\b|\bundefined\b/gi, '').replace(/_/g, ' ').replace(/\s*(at|on|in|,)\s*$/i, '').replace(/\s{2,}/g, ' ').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function fmtDate(s) {
      if (!s) return '';
      try { var d = new Date(String(s).replace(' ', 'T')); if (isNaN(d.getTime())) return esc(s); return d.toLocaleString('en-IN', { month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }); } catch (e) { return esc(s); }
    }
    function getScans(data) {
      if (!data) return [];
      if (Array.isArray(data.tracking)) return data.tracking;
      if (data.tracking && Array.isArray(data.tracking.scans)) return data.tracking.scans;
      if (Array.isArray(data.scans)) return data.scans;
      if (Array.isArray(data.history)) return data.history;
      return [];
    }
    function renderShipment(awb, data) {
      var scans = getScans(data)
        .filter(function (r) { return !(r && r.status_code === 'NIMBUS' && (r.ship_status || '').toLowerCase() !== 'delivered'); })
        .map(function (r) { return { msg: clean(r.message || r.ship_status || r.status || ''), loc: clean(r.location || ''), time: r.event_time || r.status_date_time || r.date || '', ship: clean(r.ship_status || r.status || '') }; })
        .filter(function (x) { return x.msg; });
      var latest = scans.length ? scans[scans.length - 1] : null;
      var courier = clean((data && data.courier && data.courier.display_name) || '');
      var edd = data && data.edd ? fmtDate(data.edd) : '';
      var current = (latest && (latest.ship || latest.msg)) || clean((data && (data.current_status || data.ship_status)) || '');
      var head = '<div class="track-res__head"><div><span class="track-res__awb-label">AWB</span><span class="track-res__awb">' + esc(awb) + '</span></div>' + (current ? '<span class="track-res__status">' + esc(current) + '</span>' : '') + '</div>'
        + '<div class="track-res__meta">' + (courier ? '<span>Courier: ' + esc(courier) + '</span>' : '') + (edd ? '<span>Est. delivery: ' + esc(edd) + '</span>' : '') + '</div>';
      var body;
      if (!scans.length) {
        body = '<p class="track-res__empty">Tracking details will appear here once your package reaches the courier facility. Please check back soon.</p>';
      } else {
        var items = scans.slice().reverse().map(function (x, i) {
          var sub = [esc(x.loc), fmtDate(x.time)].filter(Boolean).join(' &middot; ');
          return '<li class="track-res__step' + (i === 0 ? ' is-current' : '') + '"><span class="track-res__dot" aria-hidden="true"></span><div><p class="track-res__msg">' + esc(x.msg) + '</p>' + (sub ? '<p class="track-res__sub">' + sub + '</p>' : '') + '</div></li>';
        }).join('');
        body = '<ol class="track-res__steps">' + items + '</ol>';
      }
      return '<article class="track-res card">' + head + body + '</article>';
    }
    function showError(msg) { if (results) { results.hidden = true; results.innerHTML = ''; } if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
    var goT0 = 0;
    function setLoading(on, ok) {
      if (!submitBtn) return;
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) { goT0 = Date.now(); submitBtn.disabled = true; submitBtn.classList.remove('fail'); submitBtn.classList.add('go'); }
      else {
        if (ok === false) submitBtn.classList.add('fail');
        setTimeout(function () { submitBtn.classList.remove('go'); submitBtn.classList.remove('fail'); submitBtn.disabled = false; }, Math.max(0, 2700 - (Date.now() - goT0)));
      }
    }
    function renderResults(html) { if (errEl) errEl.hidden = true; if (results) { results.innerHTML = html; results.hidden = false; } }
    function fetchAwb(awb) { return fetch(base + '/shipment/track/track-awb/' + encodeURIComponent(awb), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (input.value || '').trim();
      if (!val) { showError(mode === 'awb' ? 'Please enter your AWB number.' : 'Please enter your order ID.'); return; }
      setLoading(true); if (errEl) errEl.hidden = true;
      if (mode === 'awb') {
        fetchAwb(val).then(function (res) {
          if (res && res.status && res.data && res.data.exists !== false && getScans(res.data).length >= 0 && (getScans(res.data).length > 0 || res.data.courier || res.data.awb_number)) { setLoading(false, true); renderResults(renderShipment(val, res.data)); }
          else { setLoading(false, false); showError('No shipment found for that AWB number. Please check the number and try again.'); }
        }).catch(function () { setLoading(false, false); showError('Could not reach tracking right now. Please try again in a moment.'); });
      } else {
        fetch(base + '/shipment/track/track-order', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ type: 'orderId', orderId: val }) })
          .then(function (r) { return r.json(); }).then(function (res) {
            var d = res && res.data;
            var records = (d && d.data && d.data.records) || (d && d.records) || [];
            var awbs = records.map(function (x) { return x.awbNumber || x.awb_number || x.awb; }).filter(Boolean);
            awbs = awbs.filter(function (a, i) { return awbs.indexOf(a) === i; }).slice(0, 5);
            if (!res || !res.status || !awbs.length) { setLoading(false, false); showError('No shipment found for that order ID yet. If you ordered recently, tracking appears once it ships. Check your confirmation email, or try your AWB.'); return; }
            Promise.all(awbs.map(function (a) { return fetchAwb(a).then(function (r) { return { awb: a, data: (r && r.data) || {} }; }).catch(function () { return { awb: a, data: {} }; }); }))
              .then(function (list) { setLoading(false, true); renderResults(list.map(function (it) { return renderShipment(it.awb, it.data); }).join('')); });
          }).catch(function () { setLoading(false, false); showError('Could not reach tracking right now. Please try again in a moment.'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
